//#region import libraries
// react
import React, { useState } from "react";
import { Title as CustomTitle, NewScreen } from "_atoms";

// screens
import CreateBooking from "_scenes/portal/assistance-bookings/create-booking";
import BookingRequests from '_scenes/portal/assistance-bookings/booking-requests';
import BookingHistory from "_scenes/portal/assistance-bookings/booking-history";
import SitaMessagesTable from "../sita-messages";

// bootstrap
import { Row, Col } from 'react-bootstrap';

// icons
import { IoAirplaneOutline, IoListOutline, IoTimeOutline, IoMailOutline } from 'react-icons/io5';

//redux
import { useSelector } from "react-redux";
import { selectUserDb } from "_redux/slices/main-screen/user";

// styles
import { Colors } from '_styles';
import { useIsMobile } from '_utils/hooks';

//#endregion

const tabConfig = [
    { value: "1", label: "Create Request", icon: IoAirplaneOutline },
    { value: "2", label: "Request Table", icon: IoListOutline },
    // { value: "3", label: "Request History", icon: IoTimeOutline },
];

const BookingsHome = () => {
    const [tab, setTab] = useState("1");
    const dbUser = useSelector(selectUserDb);
    // phones: tabs scroll sideways instead of overflowing, with tighter padding
    const isMobile = useIsMobile();

    const allTabs = [
        ...tabConfig,
        ...(dbUser?.details.type === "AIRPORT"
            ? [{ value: "4", label: "SITA Messages", icon: IoMailOutline }]
            : []),
    ];

    return (
        <NewScreen>
            {/* Page Header */}
            <Row>
                <Col>
                    <CustomTitle
                        name="Assistance Bookings"
                        subtitle="Assistance Bookings"
                        description="Manage PRM booking requests in your airport"
                    />
                </Col>
            </Row>

            {/* Tab Navigation */}
            <div style={{ ...styles.tabBar, ...(isMobile && { overflowX: 'auto', overflowY: 'hidden', gap: 4 }) }}>
                {allTabs.map(({ value, label, icon: Icon }) => {
                    const active = tab === value;
                    return (
                        <button
                            key={value}
                            onClick={() => setTab(value)}
                            style={{
                                ...styles.tabButton,
                                ...(isMobile && { padding: '10px 12px', fontSize: 13, marginBottom: 0 }),
                                ...(active ? styles.tabButtonActive : {}),
                            }}
                        >
                            <Icon
                                size={18}
                                style={{ marginRight: 8, flexShrink: 0 }}
                                color={active ? Colors.PRM_LIGHT_BLUE : Colors.GRAY_DARK}
                            />
                            <span>{label}</span>
                        </button>
                    );
                })}
            </div>

            {/* Tab Content */}
            <div style={{ ...styles.tabContent, ...(isMobile && { marginTop: 16 }) }}>
                {tab === "1" && <CreateBooking />}
                {tab === "2" && <BookingRequests />}
                {tab === "3" && <BookingHistory />}
                {tab === "4" && <SitaMessagesTable />}
            </div>
        </NewScreen>
    );
};

const styles = {
    tabBar: {
        display: 'flex',
        gap: 8,
        marginTop: 24,
        borderBottom: `2px solid ${Colors.GRAY_LIGHT}`,
        paddingBottom: 0,
    },
    tabButton: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px 20px',
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        color: Colors.GRAY_DARK,
        borderBottom: '2px solid transparent',
        marginBottom: -2,
        transition: 'all 0.2s ease',
        borderRadius: '8px 8px 0 0',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    tabButtonActive: {
        color: Colors.PRM_LIGHT_BLUE,
        borderBottomColor: Colors.PRM_LIGHT_BLUE,
        backgroundColor: Colors.PRM_BLUE_ACCENT,
    },
    tabContent: {
        marginTop: 24,
    },
};

export default BookingsHome;
